import { getTheme } from '@cw-ui/asio-neon-themes';
import { createTheme, ThemeProvider, useMediaQuery } from '@mui/material';
import React from 'react';
import { deepmerge } from '@mui/utils';

const AsioNeonResponsiveThemeProvider = ({ children }) => {
    const theme = getTheme('light');
    const buttonSize = useMediaQuery(theme.breakpoints.down('lg')) ? 'medium' : 'large';

    const enhancedTheme = createTheme(
        deepmerge(theme, {
            typography: {
                fontFamily: [
                    'Inter',
                    '-apple-system',
                    'BlinkMacSystemFont',
                    '"Segoe UI"',
                    'Roboto',
                    '"Helvetica Neue"',
                    'Arial',
                    'sans-serif',
                    '"Apple Color Emoji"',
                    '"Segoe UI Emoji"',
                    '"Segoe UI Symbol"',
                ].join(','),
            },
            components: {
                MuiButton: {
                    defaultProps: {
                        size: buttonSize,
                        disableRipple: true,
                    },
                },
            },
        })
    );

    return <ThemeProvider theme={enhancedTheme}>{children}</ThemeProvider>;
};

export default AsioNeonResponsiveThemeProvider;
